import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import confirmimg from '../assets/images/confirmpopup.gif';
import styles from './SuccessPopUp.module.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function SuccessPopUp(props) {
  const {
    successMessage,
    open,
    handleSuccessPopup
  } = props;

  return (
    <BootstrapDialog
      onClose={() => handleSuccessPopup(false)}
      aria-labelledby="customized-dialog-title"
      open={open}
      className={`${styles['popup-message-box']}`}
      PaperProps={{ classes: { root: styles['dialog-paper'] } }}
    >
      <DialogContent dividers className={`${styles['popup-content']}`}>
        <span className={`${styles['success-close-icon']}`} onClick={() => handleSuccessPopup(false)}>
          <CloseIcon sx={{ fontSize: 40 }} />
        </span>
        <div className={`${styles['popup-message-img']}`}>
          <img src={confirmimg} alt="" />
        </div>
        <h1>Thank you</h1>
        <p>{successMessage}</p>
      </DialogContent>
    </BootstrapDialog>
  );
}
